import React from "react";
import { ArrowDown } from "lucide-react";
import { hero } from "../mock";

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById("contacto")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative bg-[#efe9e3] pt-32 pb-20 md:pt-40 md:pb-28">
      <div className="mx-auto max-w-6xl px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left */}
          <div className="max-w-xl">
            <div className="inline-flex items-center gap-2 rounded-full border border-[#16204a]/15 bg-white/60 px-4 py-2">
              <span className="h-1.5 w-1.5 rounded-full bg-[#2f52c4]" />
              <span className="text-xs font-bold uppercase tracking-[0.18em] text-[#2f52c4]">
                {hero.badge}
              </span>
            </div>

            <h1 className="mt-6 font-extrabold leading-[0.98] tracking-tight text-[#16204a]">
              <span className="block text-5xl md:text-6xl lg:text-7xl">
                {hero.titleLine1}
              </span>
              <span className="block text-5xl md:text-6xl lg:text-7xl">
                {hero.titleLine2}
              </span>
              <span className="block text-5xl md:text-6xl lg:text-7xl">
                {hero.titleLine3}
              </span>
            </h1>

            <p className="mt-6 text-lg text-[#16204a]/90">{hero.lead}</p>
            <p className="mt-4 text-base leading-relaxed text-[#4a4f63]">
              {hero.description}
            </p>

            <div className="mt-7 flex flex-wrap gap-3">
              {hero.tags.map((tag) => (
                <span
                  key={tag}
                  className="rounded-full bg-white/70 px-4 py-2 text-sm font-semibold text-[#16204a] shadow-sm"
                >
                  {tag}
                </span>
              ))}
            </div>

            <button
              onClick={scrollToContact}
              className="group mt-9 inline-flex items-center gap-3 rounded-full bg-[#2f52c4] pl-7 pr-2 py-2.5 text-sm font-bold uppercase tracking-[0.12em] text-white transition-all duration-300 hover:bg-[#243fa0] hover:scale-[1.02] active:scale-95"
            >
              {hero.cta}
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#f5c842] text-[#16204a] transition-transform duration-300 group-hover:translate-y-0.5">
                <ArrowDown size={18} strokeWidth={2.5} />
              </span>
            </button>
          </div>

          {/* Right */}
          <div className="relative">
            <div className="overflow-hidden rounded-2xl shadow-2xl">
              <img
                src={hero.image}
                alt={hero.imageAlt}
                className="h-[380px] md:h-[520px] w-full object-cover"
              />
            </div>
            <div className="absolute bottom-0 left-0 rounded-tr-2xl rounded-bl-2xl bg-white px-7 py-5 shadow-xl">
              <div className="text-3xl font-extrabold text-[#16204a]">
                {hero.stat.value}
              </div>
              <div className="text-xs font-bold uppercase tracking-[0.14em] text-[#4a4f63]">
                {hero.stat.label}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
